
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useDeleteTaskMutation } from 'core/api/tasks';
import { useInvalidateContacts } from 'core/api/contacts';
import { useModalStore } from 'stores/modal';
import { ModalType } from 'core/useCases/modal/types';
import Delete from 'images/icons/Delete.svg?react';
import { useHistory, useLocation } from 'react-router-dom';

type DeleteTaskButtonProps = {
    taskId: string;
};

const DeleteTaskButton: FC<DeleteTaskButtonProps> = ({ taskId }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { pathname } = useLocation();
    const isContactPage = pathname.split('/')[1] === 'contact';
    const deleteTaskMutation = useDeleteTaskMutation();
    const invalidateContacts = useInvalidateContacts();
    const openModal = useModalStore((s) => s.openModal);

    const openConfirmationModal = () => {
        openModal({
            confirmAction: async () => {
                try {
                    await deleteTaskMutation.mutateAsync(taskId);

                    // TODO: for contact deletion button recheck, fetch only updated data
                    await invalidateContacts();

                    toast.success(t('task-list.remove-task-success'));
                    // No redirection if on contact page
                    if (!isContactPage) {
                        history.push('/activities');
                    }
                } catch (error) {
                    toast.error(t('task-list.remove-task-error'));
                }
            },
            title: t('task-list.ask-to-delete-task'),
            type: ModalType.Confirmation,
        });
    };

    return (
        <button onClick={openConfirmationModal} title={t('common.delete')} type="button">
            <Delete />
        </button>
    );
};

export default DeleteTaskButton;
